import type * as React from 'react';
import { get } from '@Domain/Api';
import usersFetched, {
	type UsersFetchedAction,
	type UsersListFetchedPayload,
} from '@Application/Users/Users/Actions/usersFetched';
import usersFetchFailed, {
	type UsersFetchFailedAction,
} from '@Application/Users/Users/Actions/usersFetchFailed';
import type FetchAccountUsers from '@Application/Users/Users/Queries/FetchAccountUsers';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = UsersFetchedAction | UsersFetchFailedAction;

export default (query: FetchAccountUsers) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// Server-side pagination: `get` is used deliberately, never `getPaginated` (which walks every
			// page and would make `totalRecords` lie to the paginator).
			const baseUrl = `${parameters.api.host}/api/accounts/${query.accountId}/users`;
			const queryString = query.toQueryString();
			const url = queryString.length > 0 ? `${baseUrl}?${queryString}` : baseUrl;

			const payload = await get<UsersListFetchedPayload>(url);

			const action = usersFetched(payload, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = usersFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
